"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EFormInputType;
(function (EFormInputType) {
  EFormInputType["Checkbox"] = "checkbox";
  EFormInputType["Mask"] = "mask";
  EFormInputType["Address"] = "address";
  EFormInputType["Number"] = "number";
  EFormInputType["Text"] = "text";
  EFormInputType["INN"] = "INN";
  EFormInputType["Select"] = "select";
  EFormInputType["SelectDictionaries"] = "selectDictionaries";
  EFormInputType["LanguageText"] = "language_text";
  EFormInputType["TextArea"] = "textarea";
})(EFormInputType || (EFormInputType = {}));
var _default = EFormInputType;
exports.default = _default;